// extracted by mini-css-extract-plugin
module.exports =  {"toolbar":"styles__toolbar"};